import type { Ref } from 'vue'
import type { BridgeQuoteResult, SolanaBridgeProvider } from './contracts'
import type { RoutePresentation } from './presentation'

export interface QuotesApi {
  isFresh: Readonly<Ref<boolean>>
  solanaBridgeProvider: Readonly<Ref<SolanaBridgeProvider>>
  hasPrerequisites: () => boolean
  requote: () => Promise<void>
  scheduleRequote: (force?: boolean) => void
  scheduleInitialQuote: () => void
  syncForSelection: () => void
  selectSolanaBridgeProvider: (provider: SolanaBridgeProvider) => void
  presentRoute: (
    quote: Pick<BridgeQuoteResult, 'provider' | 'execution'> | null
  ) => RoutePresentation
}

let installed: QuotesApi | null = null

export const installQuotes = (api: QuotesApi): void => {
  installed = api
}

export const getQuotes = (): QuotesApi => {
  if (!installed) throw new Error('quotes_not_installed')
  return installed
}
